<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>Warehousing Charge Rates</h2>

    <div>
      <button class='btn btn-secondary' routerLink='/warehousing/storage-rates/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <br />
  <p class='text-muted'>
    A price change is a new rate with a later start date, not an edit to the old one &mdash; that is what
    lets a closed month still reproduce its invoices. Edit an existing rate only to correct a mistake.
  </p>
  <br />
  <app-grid
    entity='warehouse-storage-rate'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
  ></app-grid>
</div>
